module.exports = __webpack_public_path__ + "static/dmon-006-28b3c14693ba42dc0a1f3b79d73b84a7.jpg";